import { AppStore } from '../../stores/AppStore'
import { themeDreher } from '../../styles/themeDreher'
import { themePeroni } from '../../styles/themePeroni'
import { themePrazdroj } from '../../styles/themePrazdroj'
import { themeUrsus } from '../../styles/themeUrsus'

type ThemeLocalesType = 'it' | 'cs' | 'en' | 'hu' | 'ro'

export const isPeroniThemeActive = (): boolean => {
  return process.env.NEXT_PUBLIC_THEME === 'peroni'
}
export const isPrazdrojThemeActive = (): boolean => {
  return process.env.NEXT_PUBLIC_THEME === 'prazdroj'
}
export const isDreherThemeActive = (): boolean => {
  return process.env.NEXT_PUBLIC_THEME === 'dreher'
}
export const isUrsusThemeActive = (): boolean => {
  return process.env.NEXT_PUBLIC_THEME === 'ursus'
}

export const getThemeName = (): string => {
  return process.env.NEXT_PUBLIC_THEME || 'prazdroj'
}

export const isPrazdrojSKDomainActive = (): boolean => {
  return window.location.hostname.includes('.prazdrojonline.sk')
}

export const getChakraTheme = () => {
  if (isPeroniThemeActive()) {
    return themePeroni
  }
  if (isDreherThemeActive()) {
    return themeDreher
  }
  if (isUrsusThemeActive()) {
    return themeUrsus
  }

  return themePrazdroj
}

export const getThemeLocale = (): ThemeLocalesType => {
  if (isPeroniThemeActive()) {
    return 'it'
  }
  if (isDreherThemeActive()) {
    return 'hu'
  }
  if (isUrsusThemeActive()) {
    return 'ro'
  }

  return 'cs'
}

export const getThemeFavicon = (): string => {
  if (isPeroniThemeActive()) {
    return '/img/favicons/favicon-it.ico'
  }
  if (isDreherThemeActive()) {
    return '/img/favicons/favicon-hu.ico'
  }
  if (isUrsusThemeActive()) {
    return '/img/favicons/favicon-ro.ico'
  }

  return '/img/favicons/favicon-cz.ico'
}

export const getLogoLinkByTheme = (): string | undefined => {
  if (isPeroniThemeActive()) {
    return 'https://portal.birraperoniperte.it/'
  }

  // TODO: add URL's when client provides them
  if (isDreherThemeActive()) {
    return undefined // 'https://www.dreher.hu/' ???
  }

  if (isUrsusThemeActive()) {
    return undefined // 'https://www.ursus.ro/' ???
  }

  if (AppStore.activeLocale === 'sk') {
    return 'https://www.prazdrojonline.sk/'
  }

  return 'https://www.prazdrojonline.cz/'
}

export const getThemeDropdownLanguages = (): {
  label: string
  value: string
}[] => {
  if (isPeroniThemeActive()) {
    return [
      {
        label: 'Italiano',
        value: 'it',
      },
      {
        label: 'English',
        value: 'en',
      },
    ]
  }
  if (isDreherThemeActive()) {
    return [
      {
        label: 'Magyar',
        value: 'hu',
      },
      {
        label: 'English',
        value: 'en',
      },
    ]
  }
  if (isUrsusThemeActive()) {
    return [
      {
        label: 'Romanian',
        value: 'ro',
      },
      {
        label: 'English',
        value: 'en',
      },
    ]
  }
  return [
    {
      label: 'Čeština',
      value: 'cs',
    },
    {
      label: 'Slovenčina',
      value: 'sk',
    },
    {
      label: 'English',
      value: 'en',
    },
    {
      label: 'Italiano',
      value: 'it',
    },
    {
      label: 'Deutsch',
      value: 'de',
    },
  ]
}
